import React, { useState } from 'react'
import { Card, IconButton } from '@st-operations/uikit/src/v2'
import classnames from 'classnames'

const TABS = {
  DESCRIPTION: 'Description',
  DESCRIPTORS: 'Descriptors',
  INDUSTRIES: 'Industries',
}

const DiffBotInfo = (props) => {
  const [activeTab, setActiveTab] = useState(TABS.DESCRIPTION)

  const handleChangeTab = (tab) => (event) => {
    event.preventDefault()
    setActiveTab(tab)
  }

  return (
    <div className="domain-details-modal__diff-bot">
      <For each="tab" index="index" of={Object.values(TABS)}>
        <Card
          key={tab}
          className={classnames(
            'domain-details-modal__diff-bot-section',
            activeTab === tab && 'open'
          )}
        >
          <header className="domain-details-modal__diff-bot-header">
            <h1 className="domain-details-modal__diff-bot-title">{tab}</h1>
            <If condition={activeTab !== tab}>
              <IconButton
                iconProps={{
                  icon: 'angledown',
                  type: 'outline',
                  width: '24px',
                  height: '24px',
                }}
                onClick={handleChangeTab(tab)}
                ariaLabel={`show ${tab} value`}
                classes={{
                  icon: classnames('collapsible__icon-collapsible'),
                  button: 'collapsible__button-collapsible',
                }}
              />
            </If>
          </header>
          <If condition={activeTab === tab}>
            <div className="domain-details-modal__diff-bot-content">
              <p className="domain-details-modal__diff-bot-text">
                {props[tab.toLowerCase()] || 'No data available for this domain'}
              </p>
            </div>
          </If>
        </Card>
      </For>
    </div>
  )
}

export default DiffBotInfo
